import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { messagesDashboardQuery } from "../../../../shared/utils/entitiesFiltersUtils";
import Message from "../../../../shared/components/features/message/Message";
import MessagesWidgetEditorFlow from "./messagesWidgetEditorFlow/MessagesWidgetEditorFlow";
import Widget from "../../../../shared/components/features/widget/Widget";
import boardType from "../../../../shared/enums/boardType";
import pathRouts from "../../../../shared/enums/pathRoute";
import ScrollLTR from "../../../../shared/components/ui/scrollLTR/ScrollLTR";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import actionType from "../../../../shared/enums/actionType";
import noMessagesImg from "../../../../assests/emptyList/message.png";
import classes from "./MessagesWidget.module.css";

const MessagesWidget = () => {

    const listRef = useRef(null);
    const navigate = useNavigate();
    const { texts, lang } = useSelector(state => state.translate);
    const { user, userDetails, isManager } = useSelector(state => state.auth);
    const studyGroups = userDetails?.defaultSchool?.mainClasses?.map(c => c.id);
    const messages = useSelector(state => selectEntitiesByFilters(state, messagesDashboardQuery(lang, studyGroups)));
    const [messageDraft, setMessageDraft] = useState({ draft: null, type: "" });

    const isManagerSystemMessage = (message) => {
        return isManager && message.messageFilters?.some(f => f.schoolId);
    }
    const navigateToSystemMessages = () => {
        navigate(`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.SYSTEMMESSAGES}`);
    }

    const getEditAction = (message) => {
        if (isManagerSystemMessage(message))
           return navigateToSystemMessages;
        if (CanEditMessage(message, studyGroups, user))
            return () => setMessageDraft({ draft: { ...message, studyGroupId: message.nmmIds?.[0] ?? studyGroups?.[0] }, type: actionType.edit });
        return null;
    };

    const getDeleteAction = (message) => {
        if (isManagerSystemMessage(message))
            return navigateToSystemMessages;
        if (CanEditMessage(message, studyGroups, user))
            return () => setMessageDraft({ draft: message, type: actionType.delete });
        return null;
    };

    return (
        <Widget
            color="#BBA9E0"
            title={texts.messagesBoard}
            icon={iconsList.messages}
            className={classes.MessagesWidget}
            contentScrollable={false}
        >
            <div className={classes.MessagesContent}>
                {messages?.length > 0 ? (
                    <ScrollLTR height="100%">
                        <div className={classes.MessagesList} ref={listRef}>
                            {messages.map(message =>
                                <Message
                                    key={message.id}
                                    {...message}
                                    onEdit={getEditAction(message)}
                                    onDelete={getDeleteAction(message)}
                                />
                            )}
                        </div>

                    </ScrollLTR>
                ) : (
                    <div className={classes.NoMessages}>
                        {texts.noMessages}
                        <img src={noMessagesImg} alt={texts.noMessages} className={classes.EmptyImage} />
                    </div>
                )}

                { CanEditMessage(null, studyGroups, user) &&
                    <MessagesWidgetEditorFlow className={classes.MessageInputArea} messageDraft={messageDraft} setMessageDraft={setMessageDraft} studyGroups={studyGroups} boardId={boardType.dashboardMessages} homeroomClass={true} />
                }
            </div>
        </Widget>
    );
};

export default MessagesWidget;

const CanEditMessage = (message = null, studyGroups, user) => {
    if (!studyGroups || studyGroups?.length <= 0)
        return false;
    if (window.config.whiteListMessages?.length > 0 && !window.config.whiteListMessages?.includes(user?.exidentifier))
        return false;
    if (!message)
        return true;
    if (!message.isOwner)
        return false;
    return true;
};
